module.exports = __webpack_public_path__ + "static/media/1_Pokana_OSA_Formplast_GFO_20160622.52c1ceb2.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2016/1_Pokana_OSA_Formplast_GFO_20160622.pdf
// module id = 164
// module chunks = 0